/** Les discussions, les groupes et les amis. */
export const messages = {
  amis: {
    croise: 'Tu l’as croisé en événement',
    soiMeme: "On ne peut pas s'ajouter soi-même",
    compteOfficiel: "Le compte de l'application ne se demande pas en ami. Tu peux lui écrire.",
    bloque: 'Tu as bloqué ce membre : débloque-le avant de le demander en ami',
    refuse: 'Ce membre n’accepte pas ta demande pour le moment',
    plusDeDemande: "Cette demande n'existe plus",
    nouveau: 'Nouveau sur le spot',
  },
  erreurs: {
    plusDeConversation: "Cette conversation n'existe plus",
    pasMembre: 'Tu ne fais pas partie de cette conversation',
    demandeEnAttente: 'Ton message est parti. Tu pourras poursuivre quand cette personne t’aura répondu.',
    plusAmis: "Vous n'êtes plus amis : cette conversation est fermée",
    injoignable: 'Ce membre ne reçoit pas tes messages pour le moment',
    vide: "Écris un message avant de l'envoyer",
    effacerLesSiens: 'Tu ne peux effacer que tes propres messages',
    modifierLesSiens: 'Tu ne peux modifier que tes propres messages',
    tropTardPourModifier: 'Un message ne se modifie que dans les 15 minutes qui suivent son envoi.',
    priveSansNom: "Une conversation privée n'a pas de nom",
    renommerAdmin: "Seul l'administrateur peut renommer le groupe",
    nomDuGroupe: 'Donne un nom au groupe',
    priveSansDescription: "Une conversation privée n'a pas de description",
    descriptionAdmin: "Seul l'administrateur peut changer la description",
    priveSansAdmin: "Une conversation privée n'a pas d'administrateur",
    passerAdmin: "Seul l'admin du groupe peut passer la main",
    plusDansLeGroupe: "Ce membre n'est plus dans le groupe",
    priveSansMembres: "Une conversation privée n'a pas de membres",
    retirerAdmin: "Seul l'admin du groupe peut retirer un membre",
    utiliseQuitter: 'Utilise « Quitter le groupe »',
    priveSansPhoto: "Une conversation privée n'a pas de photo",
    photoAdmin: "Seul l'admin du groupe peut changer sa photo",
    soiMeme: 'On ne discute pas avec soi-même',
    bloque: 'Tu as bloqué ce membre. Débloque-le depuis son profil pour lui écrire.',
    priveFermee: "Une conversation privée n'accueille pas d'autres membres",
    groupeDeSortie: 'On rejoint ce groupe en rejoignant la sortie, pas sur invitation',
    groupeDAsso: 'On rejoint ce groupe en rejoignant l’association, pas sur invitation',
    amisSeulement: 'Tu ne peux ajouter que tes amis à un groupe',
    priveNeSeQuittePas: 'Une conversation privée ne se quitte pas',
    successeur: 'Choisis qui reprend le groupe avant de partir.',
  },
  apercu: {
    groupe: 'Groupe',
    photo: 'Photo',
    vocal: 'Message vocal',
    video: 'Vidéo',
    sortie: 'Événement partagé',
    post: 'Post partagé',
    nouveau: 'Nouveau message',
  },
  commun: {
    photo: 'Photo',
    vocal: 'Message vocal',
    video: 'Vidéo',
    sortie: 'Événement partagé',
    post: 'Post partagé',
    message: 'Message',
    supprime: 'Message supprimé',
    ecrit: 'écrit...',
    nouveauMessage: 'Nouveau message',
    quitterGroupe: 'Quitter le groupe',
    aucunMembre: 'Aucun membre trouvé',
    verifie: 'Vérifie l’orthographe du pseudo.',
    aucunAmi: 'Aucun ami pour l’instant',
    chercheUnPseudo: 'Cherche un pseudo pour inviter quelqu’un qui n’est pas encore ton ami.',
    rechercherPseudo: "Rechercher un nom d'utilisateur...",
    infosGroupe: 'Infos du groupe',
    membres: 'Membres',
    toi: 'Toi',
    moi: 'Moi',
    retirerQuelquun: (nom: string) => `Retirer ${nom}`,
    laisserEtPartirQ: (nom: string) => `Laisser le groupe à ${nom} et partir ?`,
  },
  conversation: {
    pasParti: "Ce message n'a pas pu partir.",
    pasModifie: "Ce message n'a pas pu être modifié.",
    microIndisponible: 'Micro indisponible',
    vocalImpossible: 'Envoi du vocal impossible',
    envoiImpossible: 'Envoi impossible pour le moment.',
    copie: 'Message copié.',
    plusCharge: "Ce message n'est plus dans la partie chargée du fil.",
    reactionEchec: "La réaction n'est pas passée. Réessaie.",
    effacement: "Les messages s'effacent une semaine après avoir été lus.",
    pasAmis: 'Vous n’êtes pas amis : tu ne peux envoyer qu’un seul message. La conversation s’ouvrira si cette personne te répond.',
    dernierMessage: 'Aller au dernier message',
    plusAmis: "Vous n'êtes plus amis : cette conversation est fermée. Demande-le à nouveau en ami depuis son profil pour reprendre la discussion.",
    voirCite: 'Voir le message cité',
    annulerReponse: 'Ne plus répondre à ce message',
    annulerModif: 'Ne plus modifier ce message',
    modifierLeMessage: 'Modifier le message',
    ecrire: 'Écrire un message...',
    annulerEnregistrement: "Annuler l'enregistrement",
    reprendre: "Reprendre l'enregistrement",
    galerie: 'Choisir dans la galerie',
    enregistrerVocal: 'Enregistrer un message vocal',
    lacherAnnuler: 'Lâcher pour annuler',
    lacherEnvoyer: 'Lâcher pour envoyer',
    envoyerVocal: 'Envoyer le message vocal',
    envoyer: 'Envoyer',
    actions: 'Actions sur le message',
    autreEmoji: 'Choisir un autre emoji',
    repondre: 'Répondre',
    copier: 'Copier le texte',
    modifier: 'Modifier',
    infos: 'Infos',
    supprimerQ: 'Supprimer ce message ?',
    supprimer: 'Supprimer',
    chercherEmoji: 'Chercher un emoji',
    reactions: 'Réactions',
    retraitEchec: "Le retrait n'est pas passé. Réessaie.",
    appuyerSupprimer: 'Appuyez pour supprimer.',
    infosMessage: 'Infos du message',
    vu: 'Vu',
    pasEncore: 'pas encore',
    distribue: 'Distribué',
    ceMembre: 'ce membre',
    photoEnvoyee: 'Photo envoyée dans la discussion',
    voirReactions: 'Voir qui a réagi',
    postIndisponible: "Ce post n'est plus disponible.",
    voirProfil: (nom: string) => `Voir le profil de ${nom}`,
    plusieursEcrivent: (n: number) => `${n} personnes écrivent...`,
    appelerVideo: (nom: string) => `Appeler ${nom} en vidéo`,
    appeler: (nom: string) => `Appeler ${nom}`,
    nouveaux: (n: number) => `${n} nouveau${n > 1 ? 'x' : ''} message${n > 1 ? 's' : ''}`,
    retirerReaction: (emoji: string) => `Retirer ${emoji}`,
    reagirAvec: (emoji: string) => `Réagir avec ${emoji}`,
    aucunEmoji: (quete: string) => `Aucun emoji pour « ${quete} ».`,
    systeme: {
    retire: (nom: string) => `${nom} a été retiré du groupe.`,
    rejoint: (nom: string) => `${nom} a rejoint le groupe.`,
    quitte: (nom: string) => `${nom} a quitté le groupe.`,
    tuAsQuitte: 'Tu as quitté le groupe.',
    plusAmi: (nom: string) =>
      `Tu n’es plus ami avec ${nom}. La conversation reprendra quand vous serez de nouveau amis.`,
  },
    appel: {
    manque: (video: boolean) => `Appel ${video ? 'vidéo ' : ''}manqué`,
    duree: (video: boolean, duree: string) => `Appel ${video ? 'vidéo ' : ''}· ${duree}`,
  },
    lu: 'Lu',
    modifie: 'Modifié',
  },
  ajouterAmis: {
    titre: 'Ajouter des amis',
    boutons: {
      none: 'Ajouter',
      requested: 'Demandé',
      incoming: 'Accepter',
      friends: 'Amis',
    },
    demandesRecues: (n: number) => `Demandes reçues · ${n}`,
    suggestions: (lieu: string | null) => `Suggestions${lieu ? ` à ${lieu}` : ''}`,
    tousLesMembres: (n: number) => `Tous les membres · ${n}`,
    accepter: (nom: string) => `Accepter ${nom}`,
    refuser: (nom: string) => `Refuser ${nom}`,
  },
  ajouterMembres: {
    impossible: 'Ajout impossible pour le moment.',
    titre: 'Ajouter des membres',
    choisis: 'Choisis qui ajouter',
    resultats: 'Résultats',
    tesAmis: 'Tes amis',
    dejaMembre: 'Déjà membre',
    ajouter: (n: number) => `Ajouter ${n} membre${n > 1 ? 's' : ''}`,
  },
  groupe: {
    descriptionImpossible: 'Description impossible',
    renommageImpossible: 'Renommage impossible',
    passerImpossible: 'Impossible de passer la main',
    retirerImpossible: 'Impossible de retirer ce membre',
    photoImpossible: 'Photo impossible à enregistrer',
    quitterImpossible: 'Impossible de quitter le groupe',
    quitterQ: 'Quitter le groupe ?',
    nommerAdmin: 'Nommer administrateur',
    retirer: 'Retirer du groupe',
    changerPhoto: 'Changer la photo du groupe',
    voirPhoto: 'Voir la photo du groupe en plein écran',
    modifierNom: 'Modifier le nom du groupe',
    ajouterMembre: 'Ajouter un membre',
    modifierDescription: 'Modifier la description du groupe',
    ajouterDescription: 'Ajouter une description',
    deQuoi: 'De quoi parle ce groupe ?',
    admin: 'Admin',
    retirerQ: (nom: string) => `Retirer ${nom} du groupe ?`,
    meta: (n: number, date: string) => `${n} membres · créé le ${date}`,
  },
  passation: {
    orphelin: 'À qui confies-tu le groupe ?',
    laisser: 'À qui laisses-tu le groupe ?',
  },
  demandes: {
    titre: 'Demandes de message',
    aucune: 'Aucune demande',
    aucuneAide: 'Les premiers messages de membres que tu ne connais pas encore arriveront ici.',
  },
  liste: {
    supprimerQ: 'Supprimer cette conversation ?',
    nouveauGroupe: 'Nouveau groupe',
    demandesMessage: 'Demandes de message',
    ajouterAmis: 'Ajouter des amis',
    reactiverSon: 'Réactiver le son',
    sourdine: 'Mettre en sourdine',
    signaler: 'Signaler la conversation',
    supprimer: 'Supprimer la conversation',
    vide: 'Aucun message pour le moment',
    videAide: "Écris à quelqu'un depuis son profil, ou rejoins une sortie pour faire connaissance.",
    rechercher: 'Rechercher une discussion...',
    discussions: 'Discussions',
    messages: 'Messages',
    comptes: 'Comptes',
    envoyerUnMessage: 'Envoyer un message',
    toiDeuxPoints: 'Toi : ',
    enSourdine: 'En sourdine',
    plusAmis: 'Vous n’êtes plus amis',
    appelManque: 'Appel manqué',
    appel: 'Appel',
    premier: 'Envoyez un premier message !',
    quitterQ: (nom: string) => `Quitter ${nom} ?`,
    demandesMessageEnAttente: (n: number) => `Demandes de message · ${n} en attente`,
    demandesAmiEnAttente: (n: number) => `Demandes d'ami · ${n} en attente`,
    laisserEtPartirQ: (groupe: string, nom: string) => `Laisser ${groupe} à ${nom} et partir ?`,
    aucuneDiscussion: (recherche: string) => `Aucune discussion ne correspond à « ${recherche} ».`,
    auteur: (nom: string) => `${nom} : `,
    nonLus: 'Nouveaux messages',
    systeme: {
    quitte: (nom: string) => `${nom} a quitté le groupe`,
    retire: (nom: string) => `${nom} a été retiré du groupe`,
    rejoint: (nom: string) => `${nom} a rejoint le groupe`,
  },
  },
  nouveauGroupe: {
    impossible: 'Création impossible pour le moment.',
    titre: 'Nouveau groupe',
    creer: 'Créer le groupe',
    choisirPhoto: 'Choisir une photo de groupe',
    nom: 'Nom du groupe',
    nomExemple: 'Les pique-niques',
    description: 'Description',
    descriptionExemple: "On se retrouve au parc dès qu'il fait beau",
    chercher: "Chercher n'importe quel pseudo...",
    selectionnes: (n: number) => `${n} sélectionnés`,
  },
  annuaire: {
    rechercher: 'Chercher un membre',
    vide: "Personne d'autre pour le moment",
    videAide: 'Les membres du serveur apparaîtront ici dès qu’ils y auront accès.',
    aucun: (recherche: string) => `Aucun membre ne correspond à « ${recherche} »`,
    ecrireA: (nom: string) => `Écrire à ${nom}`,
    formation: {
      aide: "Tu apparaîtras dans son bloc de l'annuaire.",
      actuelle: 'Ta formation',
    },
    sansFormation: 'Formation non renseignée',
    voir: (nom: string) => `Voir les membres : ${nom}`,
    videFormation: 'Personne dans cette formation pour le moment',
    accueil: {
      etudiants: 'Étudiants',
      etudiantsAide: 'Tous les élèves, rangés par formation',
      associations: 'Associations',
      associationsAide: 'Leur fil, leurs événements, et comment les rejoindre',
    },
    maFormation: {
      bouton: 'Ma formation',
      choisir: 'Dire ma formation',
      aucune: 'Ne pas la dire',
      enregistree: 'Formation enregistrée',
      impossible: "Ta formation n'a pas pu être enregistrée. Réessaie.",
    },
    associations: {
      titre: 'Associations',
      /** Les familles d'associations, comme l'ecole les presente. */
      categories: { bde: 'Bureaux des élèves', citoyennes: 'Citoyennes', creatives: 'Créatives', culturelles: 'Culturelles', humanitaires: 'Humanitaires', conviviales: 'Conviviales', internationales: 'Internationales', professionnelles: 'Professionnelles', sportives: 'Sportives et clubs' },
      vide: 'Aucune association pour le moment',
      rechercher: 'Chercher une association',
      aucune: (recherche: string) => `Aucune association ne correspond à « ${recherche} »`,
      membres: (n: number) => `${n} membre${n > 1 ? 's' : ''}`,
      chef: 'Chef',
      membre: 'Membre',
      enAttente: 'Demande envoyée',
      rejoindre: 'Demander à rejoindre',
      annulerDemande: 'Annuler ma demande',
      quitter: "Quitter l'association",
      quitterQ: (nom: string) => `Quitter ${nom} ?`,
      demandeEnvoyee: 'Demande envoyée au chef',
      fil: 'Fil',
      evenements: 'Événements',
      lesMembres: 'Membres',
      ecrire: 'Écrire dans le fil',
      creerEvenement: 'Créer un événement',
      filVide: 'Rien dans le fil pour le moment',
      evenementsVide: 'Aucun événement à venir',
      demandes: (n: number) => `Demandes pour rejoindre (${n})`,
      accepter: (nom: string) => `Accepter ${nom}`,
      refuser: (nom: string) => `Refuser ${nom}`,
      retirer: (nom: string) => `Retirer ${nom} de l'association`,
      retirerQ: (nom: string) => `Retirer ${nom} de l'association ?`,
      sansChef: "Cette association n'a pas encore de chef pour accepter les demandes.",
      reserveMembres: 'Tout le monde lit son fil et ses événements ; seuls ses membres y publient.',
      groupe: 'Groupe de l’association',
      groupePasPret: 'Le groupe se prépare, réessaie dans un instant.',
      introuvable: 'Association introuvable',
      impossible: "L'action n'a pas pu aboutir. Réessaie.",
      dansLeFil: (nom: string) => `Dans le fil de ${nom}`,
      pourLAsso: (nom: string) => `Événement de ${nom}`,
      voir: (nom: string) => `Voir l'association ${nom}`,
    },
    filtres: {
      titre: 'Filtres',
      filtrer: 'Filtrer les membres',
      actifs: 'Filtres actifs',
      formation: 'Formation',
      langues: 'Langues',
      effacer: 'Tout effacer',
      fermer: 'Voir les membres',
      aucun: 'Aucun membre ne correspond à ces filtres',
    },
  },
};
